import styled from 'styled-components'

export const ShowProductImages = styled.div`
  cursor: pointer;
  border: 1px solid rgb(237, 237, 237);
  border-radius: 6px;
  text-align: center;
  padding-left: 4px;
  width: 68px;
  height: 69px;
  padding-top: 10px;
`

export const ScrollbarsContainer = styled.div`
  margin-left: 30px;
  margin-right: 10px;
  width: 80px;
`

export const ProductImg = styled.img`
  max-width: 280px;
  max-height: 280px;
  display: block;
  margin: auto;
`
